import { useAppData } from '@app/core/app-data';
import { Station } from '@mi-front/core';
import { useMutation } from '@tanstack/react-query';
import { apiClient } from '../../../api';

/**
 * Mutation hook to update a station.
 * On success, invalidates the stations query so the list refetches and stays in sync.
 */
export function useStationUpdateMutation() {
  const { refetchStations } = useAppData();

  return useMutation<Station, Error, { idOrSlug: string; data: Partial<Station> }>({
    mutationFn: ({ idOrSlug, data }) => apiClient.stations.save(idOrSlug, data),
    onSuccess: () => {
      refetchStations();
    },
  });
}
